import { styled } from '@mui/material/styles';
import { Paper, Drawer, ListItem } from '@mui/material';
import { Link } from 'react-router-dom';

export const CustomAppBar = styled('div')(({ scrolled }) => ({
  position: 'fixed',
  top: 0, left: 0, right: 0,
  zIndex: 1300,
  background: 'rgba(255,255,255,0.97)',
  backdropFilter: 'blur(12px)',
  boxShadow: scrolled ? '0 8px 32px rgba(0,0,0,0.1)' : '0 2px 10px rgba(0,0,0,0.05)',
  transition: 'all 0.45s cubic-bezier(0.32, 0.72, 0, 1)',
}));

export const NavLinkWrapper = styled(Link)(({ active }) => ({
  padding: '12px 20px',
  borderRadius: '14px',
  fontWeight: active ? 700 : 600,
  fontSize: '0.98rem',
  color: '#0a0a0a',
  textDecoration: 'none',
  position: 'relative',
  transition: 'all 0.35s ease',
  '&:hover': { background: 'rgba(253,214,73,0.12)', transform: 'translateY(-2px)' },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 6,
    left: '50%',
    width: active ? '70%' : 0,
    height: 3,
    background: '#fdd649',
    borderRadius: '3px',
    transform: 'translateX(-50%)',
    transition: 'width 0.4s ease',
  },
  '&:hover::after': { width: '70%' },
}));

export const NavButton = styled('div')(({ active }) => ({
  padding: '12px 20px',
  borderRadius: '14px',
  fontWeight: active ? 700 : 600,
  fontSize: '0.98rem',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  color: '#0a0a0a',
  transition: 'all 0.35s ease',
  position: 'relative',
  '&:hover': { background: 'rgba(253,214,73,0.12)', transform: 'translateY(-2px)' },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 6,
    left: '50%',
    width: active ? '70%' : 0,
    height: 3,
    background: '#fdd649',
    borderRadius: '3px',
    transform: 'translateX(-50%)',
    transition: 'width 0.4s ease',
  },
}));

export const CoursesDropdownPaper = styled(Paper)({
  borderRadius: '20px',
  overflow: 'hidden',
  boxShadow: '0 24px 80px rgba(0,0,0,0.18)',
  border: '1px solid rgba(253,214,73,0.3)',
  background: 'linear-gradient(135deg, #ffffff 0%, #fffaf0 100%)',
});

export const MoreDropdownPaper = styled(Paper)({
  borderRadius: '16px',
  boxShadow: '0 16px 50px rgba(0,0,0,0.15)',
  border: '1px solid rgba(253,214,73,0.25)',
  minWidth: '260px',
  background: '#ffffff',
});

// Clean, no hover effect
export const CourseItem = styled('div')({
  padding: '10px 16px',
  cursor: 'pointer',
  fontSize: '0.93rem',
  fontWeight: 500,
  color: '#333',
  borderRadius: '8px',
});

export const MoreMenuItem = styled('div')({
  padding: '14px 24px',
  cursor: 'pointer',
  borderRadius: '12px',
  margin: '6px 12px',
  fontSize: '0.95rem',
  fontWeight: 500,
  color: '#333',
});

export const AuthButton = styled('button')(({ variant = 'contained' }) => ({
  padding: '11px 28px',
  borderRadius: '30px',
  fontWeight: 600,
  fontSize: '0.94rem',
  textTransform: 'none',
  cursor: 'pointer',
  border: variant === 'outlined' ? '2px solid #ccc' : 'none',
  background: variant === 'contained' ? 'linear-gradient(135deg, #fdd649, #f7c42d)' : 'transparent',
  color: '#000',
  transition: 'all 0.35s ease',
  '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 10px 25px rgba(250,186,40,0.4)' },
}));

// FIXED HIGH Z-INDEX – mobile drawer always above header
export const MobileDrawer = styled(Drawer)({
  zIndex: 1600,
  '& .MuiDrawer-paper': {
    width: '85%',
    maxWidth: 380,
    background: '#fffef9',
    zIndex: 1600,
  },
});

export const MobileNavItem = styled(ListItem)({
  margin: '6px 12px',
  borderRadius: '14px',
  transition: '0.3s',
  '&:hover': { background: 'rgba(253,214,73,0.15)' },
});

export const CourseCategory = styled('div')({
  padding: '8px 12px',
});